import FEEDBACK_CONSTANTS from '@/constants/feedbackConstants';

export default {
  heading: 'Vi är ledsna att artikeln inte var till hjälp. Vill du berätta för oss vad som var fel?',
  text: '',
  form: {
    fields: [
      {
        type: 'checkbox',
        name: FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME,
        items: [
          {
            label: 'Informationen jag letar efter saknas',
            value: 'missing_information',
            name: FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME
          },
          {
            label: 'Det finns sakfel',
            value: 'factual_errors',
            name: FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME
          },
          {
            label: 'Vissa saker är oklara',
            value: 'not_clear',
            name: FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME
          }
        ]
      },
      {
        name: FEEDBACK_CONSTANTS.FEEDBACK_NAME,
        placeholder: 'Ge oss lite bakgrund så förbättrar vi den här artikeln.',
        type: 'textarea'
      }
    ],
    submit: {
      label: 'Skicka'
    }
  }
};